import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "flex justify-between"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AddressAutocomplete = _resolveComponent("AddressAutocomplete")!
  const _component_GMap = _resolveComponent("GMap")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!_ctx.isReadOnly)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_AddressAutocomplete, {
            actual: _ctx.actual,
            readonly: _ctx.isReadOnly,
            onChose: _ctx.onChoseAddress,
            onRemove: _ctx.onRemove,
            risultati: _ctx.risultati,
            "onUpdate:risultati": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.risultati) = $event)),
            gaddress: _ctx.address,
            "onUpdate:gaddress": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.address) = $event)),
            placeId: _ctx.placeId
          }, {
            actual: _withCtx(({actual}) => [
              _renderSlot(_ctx.$slots, "actual", { actual: actual })
            ]),
            _: 3
          }, 8, ["actual", "readonly", "onChose", "onRemove", "risultati", "gaddress", "placeId"])
        ]))
      : _createCommentVNode("", true),
    (_ctx.mapVisible)
      ? (_openBlock(), _createBlock(_component_GMap, {
          key: 1,
          readonly: _ctx.isReadOnly,
          marker: _ctx.marker,
          center: _ctx.center,
          risultati: _ctx.risultati,
          "onUpdate:risultati": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.risultati) = $event)),
          zoom: _ctx.zoom,
          onMapClick: _ctx.onMapClick,
          class: "h-80"
        }, null, 8, ["readonly", "marker", "center", "risultati", "zoom", "onMapClick"]))
      : _createCommentVNode("", true)
  ], 64))
}